import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Туроператоры, турагентства Tour Operators, Travel Agencies";

    const itemsData = [
        {
            id: 1,
            location: 'Брест',
            name: 'Общество с дополнительной ответственностью «Туристическое Агентство «ПИЛИГРИМ»',
            adress: '224005 г. Брест, ул. Советская, 49',
            url: 'http://piligrimtour.by/',
            email: 'pilgrimap@mail.ru',
            phones: [
                '(+375) 162 20-27-51 (тел/факс)',
            ],
            imgs: [
                require('./../img/ReferenceInformation/Operators/pil.jpg'),
            ],
            desc: [
                'Приоритетным направлением деятельности предприятия является создание и сопроваждение информационного банка данных по памятникам истории, культуры, архитектуры, туристским маршрутам, туристическим агентствам, возможностям организации отдыха туристов, сопутствующим услугам, обслуживающим организациям, спортивным объектам Брестчины. Размещение сведений из банка данных в Интернет, постоянно действующая и обновляемая современная система обработки и систематизации информации, подготовка и выпуск информационных материалов.',
                'Производимая продукция, услуги:',
                '- электронный банк данных по истории, культуре, достопримечательностям, туристическим маршрутам Брестской области',
                '- туры в зарубежье',
                '- организация коллективных поездок',
                '- визовая поддержка',
                '- экскурсионные поездки',
                '- шоп-туры',
                'A priority direction of activity of the enterprise is creation an information databank on monuments of history, culture, architecture, tourist routes, travel agencies, opportunities of the organization of rest of the tourists, the accompanying services, the serving organizations, sports objects Brestchiny. Accommodation of data from a databank in the Internet, permanent and updated modern system of processing and ordering of the information, preparation and release of information materials.',
                'Made production, services:',
                '- An electronic databank on history, culture, sights the tourist routes of the Brest area',
                '- Rounds in abroad',
                '- The organization of collective trips',
                '- Visa support',
                '- Excursion trips',
                '- Shop tours',
                'Предприятие работает с 1997 года.',
            ],
        },
        {
            id: 2,
            location: 'Брест',
            name: 'Общество с ограниченной ответственностью «Автотур»',
            adress: '224030 г. Брест, пр. Машерова, 35',
            email: 'aitotur@tut.by',
            phones: [
                '(+375) 162 26-74-81 (отдел туристический)',
                '(+375) 162 23-31-40 (факс)',
            ],
            desc: [
                'Все виды туристических услуг.',
                'Предприятие работает с 1991 года',
            ],
        },
        {
            id: 3,
            location: 'Брест',
            name: 'Общество с ограниченной ответственностью «Артинтур»',
            adress: '224030 г. Брест, пр. Машерова, 17 к. 101, 102',
            url: 'http://artintur.com',
            email: 'artintour@tut.by',
            phones: [
                '(+375) 162 20-11-87 (отдел туристический)',
                '(+375) 162 20-08-70 (отдел транспортный)',
                '(+375) 162 20-16-70 (факс)',
            ],
            desc: [
                'Все виды туристических услуг. Аренда автобусов туристического класса.',
                'Предприятие работает с 1993 года',
            ],
        },
        {
            id: 4,
            location: 'Брест',
            name: 'Открытое акционерное общество «Туристический комплекс «БРЕСТ-ИНТУРИСТ»',
            adress: '224000 г. Брест, проспект Машерова, 15',
            url: 'http://brest-intourist.com',
            email: 'info@brest-into',
            phones: [
                '(+375) 162 22-19-01 (генеральный директор)',
                '(+375) 162 20-05-10 (бюро по туризму)',
                '(+375) 162 22-18-85 (директор гостиницы)',
                '(+375) 162 22-19-00 (факс)',
            ],
            desc: [
                'В туристический комплекс входят: гостиница, ресторан, бары, бюро по туризму, автостоянка, летние площадки, зал совещаний.',
                'Производимая продукция, услуги:',
                '- прием туристов',
                '- туристические услуги',
                '- экскурсионные поездки',
                '- сдача в наем собственного имущества',
                '- туры в зарубежье',
                'Предприятие работает с 1975 года.',
            ],
        },
        {
            id: 5,
            location: 'Брест',
            name: 'Туристско-экскурсионное унитарное предприятие федерации профсоюзов Беларуси «Бресттурист»',
            adress: '224030 г. Брест, 6ульвар Шевченко, 6',
            phones: [
                '(+375) 162 20-26-90 (генеральный директор)',
                '(+375) 162 25-93-33 (бюро путешествий)',
                '(+375) 162 93-71-12 (туристическая база «Белое озеро»)',
                '(+375) 162 22-16-58 (факс)',
            ],
            desc: [
                'В состав предприятия входят: гостиница, ресторан, казино, автостоянка, солярий, зал совещаний, бюро путешествий и его филиалы, туристическая база «Белое озеро».',
                'Производимая продукция, услуги:',
                '- прием туристов',
                '- отдых в Республике Беларусь',
                '- экскурсии по Беларуси',
                '- туры в зарубежье',
                'Предприятие работает с 1968 года.',
            ],
        },
        {
            id: 6,
            location: 'Брест',
            name: 'Общество с ограниченной ответственностью «КРИС»',
            adress: '224023, г. Брест, ул. Советской конституции 1-21',
            url: 'http://www.kris.by',
            email: 'kristour@tut.by',
            phones: [
                '(+375) 162 41-16-39 (отдел туризма)',
                '(+375) 162 42-70-53',
                '(+375) 162 44-77-30',
                '(+375) 162 407-827 (факс)',
            ],
            imgs: [
                require('./../img/ReferenceInformation/Operators/kris.jpg'),
            ],
            desc: [
                'Собственный парк автобусов еврокласса. Богатый опыт работы на международных маршрутах.',
                'Помимо автобусных туров агентство предоставляет автобусы в аренду для перевозки пассажиров по Европе.',
                'Перевозки осуществляются следующими типами автобусов:',
                '- Автобусы фирмы «КРИС».',
                '- Автобусами класса «люкс».',
                '- Автобусы фирм из Республики Польша.',
                'Водители имеют шенгенские визы.',
                'Предприятие работает с 1995 года.',
            ],
        },
        {
            id: 7,
            location: 'Брест',
            name: 'Бюро международного молодежного туризма «Спутник»',
            adress: '224005 г. Брест, ул. Наганова, 10',
            phones: [
                '(+375) 162 23-11-42 (директор)',
                '(+375) 162 26-58-87 (отдел туризма)',
                '(+375) 162 26-56-29 (бухгалтерия)',
            ],
            desc: [
                '«БММТ «СПУТНИК» имеет собственную материальную базу (офис, гаражные боксы, туристические автобусы).',
                'Производимая продукция, услуги:',
                '- туристские услуги',
                '- перевозка пассажиров атомобильным транспортом',
                '- сдача в наем собственного имущества',
                'Предприятие работает с 1968 года.',
            ],
        },
        {
            id: 8,
            location: 'Брест',
            name: 'Брестский филиал республиканского унитарного предприятия «Дортурсервис»',
            adress: '224000 г. Брест, железнодорожная станция «Брест-Центральный»',
            phones: [
                '(+375) 162 27-30-00 (директор)',
                '(+375) 162 27-31-26 (бюро путешествий)',
                '(+375) 162 27-23-43 (ресторан)',
                '(+375) 162 27-35-87 (факс)',
            ],
            desc: [
                'В состав филиала входит: бюро путешествий и ресторан железнодорожной станции «Брест-Центральный».',
                'Производимая продукция, услуги:',
                '- прием туристов',
                '- заказ жележнодорожных билетов',
                '- обслуживание транзитных туристов',
                '- отдых в Республике Беларусь',
                '- туры в зарубежье',
                'Предприятие работает с 2001 года.',
            ],
        },
        {
            id: 9,
            location: 'Барановичи',
            name: 'Туристско-экскурсионное унитарное предприятие «Горизонт» федерации профсоюзов Беларуси',
            adress: '225310 г. Барановичи, ул. Советская, 82',
            phones: [
                '(+375) 163 2-32-36 (директор)',
                '(+375) 163 2-45-01 (бюро путешествий)',
                '(+375) 163 3-44-32 (туристическая база «Лесное озеро»)',
                '(+375) 163 2-12-54 (факс)',
            ],
            desc: [
                'В состав предприятия входят: гостиница, ресторан, автостоянка, бары, бюро путешествий, туристическая база «Лесное озеро».',
                'Производимая продукция, услуги:',
                '- прием туристов',
                '- организация отдыха',
                '- экскурсионное обслуживание',
                '- туры в зарубежье',
                '- обслуживание транзитных туристов',
                'Предприятие работает с 1970 года.',
            ],
        },
        {
            id: 10,
            location: 'Каменецкий район',
            name: 'Государственное природоохранное учреждение «Национальный парк «Беловежская пуща»',
            adress: '225063 Брестская область, Каменецкий район, поселок Каменюки',
            email: 'box@npbrom.belpak.brest.by',
            phones: [
                '(+375) 1631 2-12-83 (директор)',
                '(+375) 1631 5-63-70 (туристский комплекс)',
                '(+375) 1631 5-61-69 (факс)',
            ],
            imgs: [
                require('./../img/ReferenceInformation/Operators/puscha.jpg'),
            ],
            desc: [
                'Предприятие работает с 1939 года. В состав предприятия входят: гостиницы, гостевые дома, дома охотников, спортплощадки, выставочный центр, музей, вольеры, резиденция Деда Мороза, резиденция Вискули, ресторан, автостоянка. ГПУ НП «Беловежская пуща» - государственная организация, осуществляющая управление в области охраны природы, научной деятельности, лесного хозяйства.',
                'Производимая продукция, услуги:',
                '- прием туристов',
                '- охотничьи туры',
                '- экскурсионное обслуживание',
                '- организация отдыха',
                '- прием иностранных туристов',
            ],
        },
        {
            id: 11,
            location: 'Пинск',
            name: 'Общество с ограниченной ответственностью «Роза ветров»',
            adress: '225710 г. Пинск, ул. Черняховского, 17',
            email: 'box@npbrom.belpak.brest.by',
            phones: [
                '(+375) 165 35-07-09 (директор)',
                '(+375) 165 35-03-02 (отдел туризма)',
                '(+375) 165 35-09-09 (факс)',
            ],
            desc: [
                'Производимая продукция, услуги:',
                '- прием туристов паломнических туров по местам Холокоста',
                '- экскурсионное обслуживание',
                'Предприятие работает с 1990 года.',
            ],
        },
        {
            id: 12,
            location: 'Пинск',
            name: 'ГК «Припять»ГК «Припять»',
            adress: 'Пинск, ул. Днепровской флотилии, 35',
            email: 'box@npbrom.belpak.brest.by',
            phones: [
                '(+375) 165 35-97-47',
                '(+375) 165 35-97-66',
                '(+375) 165 35-96-30 (факс)',
            ],
        },
    ];

    let get_all_list = (data) => {
        return (
            <ul>
                {data?.map((h) => {
                    const link = "/reference-information-operators/" + h.id;
                    return (<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress != undefined && <p>{data.adress}</p>}
                {data.phones != undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url != undefined && <a href={data.url}>{data.url}</a>}
                {data.email != undefined && <p>Email: <span>{data.email}</span></p>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}